import "./App.css";
import CreateExperimentView from "./views/create-experiment-view";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExperimentDetailView from "./views/experiment-detail-view";
import ResponsiveAppBar from "./components/responsive-app-bar";
import ExperimentsListView from "./views/experiments-list-view";
import LoginView from "./views/login-view";
import { AuthContext } from "./context/auth-context";
import ProtectedRoutes from "./components/protected-routes";

function App() {
    return (
        <div className="app">
            <AuthContext>
                <BrowserRouter>
                    <ResponsiveAppBar />
                    <Routes>
                        <Route
                            path="/experiments/list"
                            element={
                                <ProtectedRoutes>
                                    <ExperimentsListView />
                                </ProtectedRoutes>
                            }
                        />
                        <Route
                            path="/experiments/create"
                            element={
                                    <CreateExperimentView />
                            }
                        />
                        <Route
                            path="/experiments/detail/:idExperiment"
                            element={
                                <ProtectedRoutes>
                                    <ExperimentDetailView />
                                </ProtectedRoutes>
                            }
                        />
                        <Route path="/login" element={<LoginView />} />

                        <Route path="*" element={<LoginView />} />
                    </Routes>
                </BrowserRouter>
            </AuthContext>
        </div>
    );
}

export default App;
